"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Data = void 0;
var runtypes_1 = require("runtypes");
exports.Data = (0, runtypes_1.Dictionary)((0, runtypes_1.Union)(runtypes_1.String, runtypes_1.Undefined));
//# sourceMappingURL=Data.js.map